import { defineStore } from 'pinia';
import { useAuthenticationState } from './authentication/state';
import { useClientStore } from './client';
import { extractStore } from './shared/extract-store';
interface UserPayloadInterface {
    username: string;
    password: string;
}

export const useAuthStore = defineStore('authentication', () => {
    const router = useRouter();
    const localeRoute = useLocaleRoute();
    const authenticationState = useAuthenticationState();

    const {
        route,
    } = useClientStore();

    const {
        $translations,
        $i18n
    } = useNuxtApp();

    // REFS FROM STORE
    const {
        settings
    } = storeToRefs(useClientStore());

    const {
        user,
        authenticated,
    } = storeToRefs(authenticationState);

    // REFS
    const translations = ref(false);
    const messages = ref([]);

    // REACTIVE
    const body = reactive({
        username: '',
        password: ''
    });

    const { execute, data, status, error } = useApiData(
        'post-account-logon',
        '/account/logon',
        { immediate: false },
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: body
        });

    const pending = computed(() => status.value === 'pending');

    async function authenticateUser({ username, password }: UserPayloadInterface) {
        messages.value.length = 0;

        body.username = username;
        body.password = password;

        await execute();

        if (data.value.payload) {
            user.value = data.value.payload; // Setting user.

            if (data.value.payload.countryCode) {
                settings.value.country = data.value.payload.countryCode; // Updating user country. Will trigger a watcher for settings.country in settings-selector.vue.
            }
            console.log('Executing route refresh.');

            await route.refresh();

            authenticated.value = true;

            console.log('AUTHENTICATED', authenticated.value)
        }

        if (data.value.isError) {
            translations.value = await $translations('$pipeline.system.account.authentication');

            messages.value.length = 0;

            if (data.value.messages.status) {
                messages.value.push({
                    title: $i18n.t(`${data.value.messages.status}.title`),
                    description: $i18n.t(`${data.value.messages.status}.description`)
                });
            }
        }
    }

    const logoff = async () => {
        return new Promise(async (resolve, _reject) => {
            const { ok, status }: any = await useApiRaw(`/${$i18n.locale.value}/account/logoff`, {
                method: 'POST'
            });

            if (ok && status === 200) {
                router.push(localeRoute({
                    name: 'index'
                })).then(() => {
                    setUser();
                    resolve(true);
                });
            }
        });
    }

    const setUser = (u?: any) => {
        if (u) {
            user.value = user;
            authenticated.value = true;
        } else {
            user.value = {};
            authenticated.value = false;
        }
    }

    return {
        ...extractStore(authenticationState),
        pending,
        messages,
        authenticateUser,
        logoff,
        setUser
    }
})